import React, {useEffect, useState} from "react";
import {useShallow} from "zustand/react/shallow";
import {useListingsStore} from "../../stores/listingsStore";
import {useSavedDealershipsStore} from "../../stores/savedDealershipsStore";

const dealerCarriesMake = (dealer, make) => {
    if (!make) return true
    const makes = dealer.makes || []
    if (makes.length === 0) return true
    const target = String(make).toLowerCase()
    return makes.some((m) => String(m).toLowerCase() === target)
}

// "Within [radius] miles of [zip]" origin control, shown in the results header.
// Commits on Enter/blur (not per-keystroke). Disabled while "My Dealers" scopes
// the search to saved dealerships — location radius is irrelevant then.
export function LocationInline() {
    const saved = useSavedDealershipsStore((state) => state.saved)
    const {filters, displayZipcode, dealerMode, setFilters} = useListingsStore(
        useShallow((state) => ({
            filters: state.filters,
            displayZipcode: state.displayZipcode,
            dealerMode: state.dealerMode,
            setFilters: state.setFilters,
        }))
    )

    const make = filters.searchTags.make
    const hasRelevant = saved.some((d) => dealerCarriesMake(d, make))
    const disabled = dealerMode === 'my' && hasRelevant

    const [zipInput, setZipInput] = useState(displayZipcode || '')
    const [radiusInput, setRadiusInput] = useState(String(filters.location.radius ?? 150))
    useEffect(() => { setZipInput(displayZipcode || '') }, [displayZipcode])
    useEffect(() => { setRadiusInput(String(filters.location.radius ?? 150)) }, [filters.location.radius])

    const commitZip = () => {
        const zip = zipInput.trim()
        if (zip.length !== 5 || zip === displayZipcode) return
        setFilters(
            {location: {...filters.location, zipcode: zip, latitude: null, longitude: null}},
            true
        )
    }

    const commitRadius = () => {
        const r = parseInt(radiusInput, 10)
        if (!r || r === filters.location.radius) return
        setFilters({location: {...filters.location, radius: r}}, true)
    }

    // Keep Enter local to this control. The Calculator page (useEnterEffect in
    // CalcPageInfo) and the Deal page (DealContext) each register a document-level
    // keydown listener that desks a Lease quote / updates the deal on Enter. This
    // is NOT a form submit (there is no form) — it's a bubbling keydown reaching
    // those listeners — so stopping propagation is the correct, minimal fix. Same
    // pattern as SearchBar's handleSearchKeyDown. blur() is what commits: it fires
    // onBlur → commitRadius/commitZip, which applies the location filter.
    const handleKeyDown = (e) => {
        if (e.key !== 'Enter') return
        e.preventDefault()
        e.stopPropagation()
        e.nativeEvent?.stopImmediatePropagation?.()
        e.currentTarget.blur()
    }

    return (
        <div className={`location-inline ${disabled ? 'disabled' : ''}`.trim()}>
            <span>Within</span>
            <input
                className="radius-inline-input"
                type="text"
                inputMode="numeric"
                maxLength={4}
                value={radiusInput}
                disabled={disabled}
                onChange={(e) => setRadiusInput(e.target.value.replace(/[^0-9]/g, ''))}
                onKeyDown={handleKeyDown}
                onBlur={commitRadius}
            />
            <span>miles of</span>
            <input
                className="zip-inline-input"
                type="text"
                inputMode="numeric"

                maxLength={5}
                value={zipInput}
                disabled={disabled}
                onChange={(e) => setZipInput(e.target.value.replace(/[^0-9]/g, ''))}
                onKeyDown={handleKeyDown}
                onBlur={commitZip}
            />
        </div>
    );
}
